import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase/config';
import { useAuth } from '../contexts/AuthContext';
import { UserRole } from '../types/user.types';

/**
 * Capital Investment page gate (Jaco 2026-10-12): ONLY the capital
 * consultant (system/capitalInvestment.consultantId — Pieter Piek) and super
 * users. Super users also get the Insights tab.
 */
export function useCanAccessCapitalInvestment(): {
  canAccess: boolean;
  isSuper: boolean;
  consultantId: string | null;
  loading: boolean;
} {
  const { userProfile } = useAuth();
  const [consultantId, setConsultantId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, 'system', 'capitalInvestment'),
      (snap) => {
        const id = snap.exists() ? (snap.data().consultantId as string | undefined) : undefined;
        setConsultantId(id || null);
        setLoading(false);
      },
      (err) => {
        console.warn('[useCanAccessCapitalInvestment] config load failed', err);
        setConsultantId(null);
        setLoading(false);
      },
    );
    return unsub;
  }, []);

  const isSuper = userProfile?.role === UserRole.PROPCLOUDAI_SUPER_USER;
  const canAccess = !!userProfile && (isSuper || (!!consultantId && userProfile.id === consultantId));
  return { canAccess, isSuper, consultantId, loading };
}
